// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-section {
  background-color: var(--color-bg-card);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 30px;
}

.detail-section h2 {
  margin-bottom: 20px;
  color: var(--color-text-light);
}

.section-toggle-arrow {
  font-size: 0.9rem;
  color: #888;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.detail-section h2:hover .section-toggle-arrow {
  opacity: 1;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.info-item label {
  font-weight: 600;
  color: var(--color-text-muted);
  font-size: 0.9rem;
}

.info-item span {
  color: var(--color-text-light);
  font-size: 1rem;
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h2 {
  margin: 0;
}

.reference-form {
  background-color: var(--color-bg-hover);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.references-list {
  display: grid;
  gap: 15px;
}

.reference-card {
  background-color: var(--color-bg-hover);
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid var(--wylie-purple);
}

.reference-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.reference-card h3 {
  margin: 0;
  color: var(--color-text-light);
}

.reference-card p {
  margin: 5px 0;
  color: var(--color-text-muted);
}

.reference-status-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  border: none;
  background-color: var(--wylie-purple);
  color: var(--wylie-white);
  margin-left: 8px;
}

.reference-content {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--color-border);
}

.reference-content p {
  background-color: var(--color-bg-card);
  padding: 15px;
  border-radius: 4px;
  margin-top: 10px;
}

.reference-received-badge {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background-color: var(--wylie-green);
  color: var(--wylie-white);
  cursor: pointer;
}

.reference-received-subtext {
  font-size: 10px;
  font-weight: 400;
  opacity: 0.9;
}

.reference-received-badge:hover {
  background-color: #154a2a;
}

.reference-received-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 400px;
  max-width: 90vw;
  max-height: 300px;
  overflow-y: auto;
  background-color: var(--color-bg-dark);
  color: var(--color-text-light);
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  margin-bottom: 10px;
  z-index: 100;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.5;
  transition: visibility 0.2s, opacity 0.2s;
}

.tooltip-from {
  font-weight: 600;
  color: #a0a0a0;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--color-bg-hover);
}

.tooltip-body {
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* A reference sent as an attachment: the file, in place of (or above) the body. */
.tooltip-attachment {
  margin-bottom: 10px;
}

.tooltip-attachment-hint {
  margin-top: 4px;
  font-size: 12px;
  color: var(--color-text-muted);
}

.reference-received-badge:hover .reference-received-tooltip {
  visibility: visible;
  opacity: 1;
}

.reference-received-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 8px;
  border-style: solid;
  border-color: var(--color-bg-dark) transparent transparent transparent;
}

.esig-gen-tip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 280px;
  max-width: 90vw;
  background-color: var(--color-bg-dark);
  color: var(--color-text-light);
  padding: 10px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  margin-bottom: 8px;
  z-index: 100;
  font-weight: normal;
  font-size: 13px;
  line-height: 1.5;
  transition: opacity 0.08s;
  pointer-events: none;
}

.esig-gen-tip-wrap:hover .esig-gen-tip {
  visibility: visible;
  opacity: 1;
}

.esig-gen-tip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 20px;
  border-width: 8px;
  border-style: solid;
  border-color: var(--color-bg-dark) transparent transparent transparent;
}

.checklist {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.checklist-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background-color: var(--color-bg-hover);
  border-radius: 6px;
  transition: background-color 0.2s;
}

.checklist-item:hover {
  background-color: var(--color-border);
}

.checklist-item input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--wylie-purple);
}

.checklist-item label {
  cursor: pointer;
  font-size: 1rem;
  color: var(--color-text-light);
  margin: 0;
  -webkit-user-select: none;
          user-select: none;
}

/* Interview pane (2026-10-03, regridded the same evening): every row shares ONE
   grid — [mark 32px] [N. Label 210px] [detail, flexible] [actions 300px, right-aligned]
   — so the step numbers form a column, the grey detail text starts in the same place
   on every row, and the selects stack on one right edge. The calendar buttons sit
   underneath as a supporting action; the job-description email is folded away. */
.interview-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.interview-row {
  display: grid;
  grid-template-columns: 32px 240px minmax(0, 1fr) 300px;
  column-gap: 12px;
  align-items: center;
  padding: 10px 12px;
}

.interview-step,
.interview-step-group {
  background-color: var(--color-bg-hover);
  border-radius: 6px;
}

.interview-step-group {
  padding: 4px 0 8px;
}

.interview-step-group .interview-row {
  padding-top: 6px;
  padding-bottom: 6px;
}

.interview-file-row .interview-step-label {
  font-weight: 500;
  color: var(--color-text-muted);
  padding-left: 16px;
}

.interview-step-mark {
  display: flex;
  justify-content: center;
  align-items: center;
}

.interview-step-mark input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: var(--wylie-purple);
  margin: 0;
}

/* Outcome rows carry a circle where the tick-box rows carry a checkbox, so the
   left column reads as one line of status marks. */
.interview-outcome-mark {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--color-border);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.interview-outcome-mark.clickable {
  cursor: pointer;
}

.interview-outcome-mark.clickable:hover,
.interview-outcome-mark.clickable:focus-visible {
  border-color: #9b4fc4;
  outline: none;
}

.interview-toggle-label {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* Yellow, not green: the pane's own colour (--part1-color). */
.interview-outcome-mark.passed {
  border-color: var(--part1-color);
  color: var(--part1-color);
}

.interview-outcome-mark.failed {
  border-color: var(--wylie-coral);
  color: var(--wylie-coral);
}

.interview-step-label {
  font-weight: 600;
  color: var(--color-text-light);
}

/* "N." in its own narrow column so the titles — and the "Book on calendar" link
   beneath them — start at the same x: the B of Book under the I of Interview. */
.interview-step-title {
  display: grid;
  grid-template-columns: 22px 1fr;
  align-items: start;
}

.interview-step-no {
  white-space: nowrap;
}

.interview-step-label label {
  cursor: pointer;
  margin: 0;
  -webkit-user-select: none;
          user-select: none;
}

.interview-step-detail {
  font-size: 13px;
  color: var(--color-text-muted);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* "Book on calendar" sits as a quiet link UNDER the step label (Pascal found the
   buttons too prominent); "New form" widened the link pair's last cell. */
.btn-link-small.interview-sub-link {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 400;
}

/* Buttons line up on the LEFT edge of the action column (one column of buttons
   down the pane); the link pairs are pushed to the right edge so their dots keep
   their own column. */
.interview-step-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.interview-steps select {
  width: 150px;
  padding: 6px 10px;
  border-radius: 5px;
  border: 1px solid #444444;
  background-color: #2a2a2a;
  color: #e0e0e0;
  font-size: 13px;
  cursor: pointer;
}

/* One button size inside the pane (the row buttons and the calendar footer alike);
   the compound selectors outrank App.css's single-class rules. */
.interview-steps .btn-primary,
.interview-steps .btn-secondary,
.interview-steps .btn-success {
  padding: 6px 12px;
  font-size: 14px;
  white-space: nowrap;
}

/* "View · Replace" / "Open form · New": first link right-aligned, the dot, then the
   second link in a fixed-width cell — so the dots line up down the column whatever
   the words are. A lone "Upload" sits in the first cell, under "View". */
.interview-link-pair {
  display: grid;
  grid-template-columns: 1fr 12px 80px;
  align-items: center;
  width: 190px;
  flex: 0 0 190px;
  margin-left: auto;
}

/* The dot between a link pair. Its own class on purpose: it used to borrow
   .interview-step-detail, which became a grid and threw the dot 70px left. */
.interview-link-dot {
  font-size: 15px;
  color: var(--color-text-muted);
}

.interview-link-pair > :nth-child(1) { justify-self: end; }
.interview-link-pair > :nth-child(2) { justify-self: center; }
.interview-link-pair > :nth-child(3) { justify-self: start; }

/* The right-hand buttons (Import from email, Create form) end on the end of
   "New form" (the link pair's last cell is wider than the word, so the pair's
   edge is not the text's). */
.interview-import-btn {
  margin-right: 16px;
}

.btn-link-small {
  background: none;
  border: none;
  padding: 0;
  font-size: 15px;
  color: var(--color-text-light);
  text-decoration: underline;
  cursor: pointer;
}

/* View in the pane's yellow, Replace in coral (it overwrites the stored file). */
.btn-link-small.btn-link-view {
  color: var(--part1-color);
}

.btn-link-small.btn-link-replace {
  color: var(--wylie-coral);
}

/* Hover in the Part 5 (Onboarding) purple — the brand purple reads too dark here. */
.btn-link-small:hover:not(:disabled) {
  color: #9b4fc4;
}

.btn-link-small:disabled {
  color: var(--color-text-muted);
  cursor: default;
  text-decoration: none;
}

.interview-optional-toggle {
  margin: 18px 0 0;
  padding: 14px 0 0 56px;
  border-top: 1px solid var(--color-border);
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-muted);
  -webkit-user-select: none;
          user-select: none;
}

.interview-optional-toggle:hover {
  color: var(--color-text-light);
}

/* The unfolded job-description block: left edge under the step numbers (56px =
   mark column + gap + row padding, same as the toggle), dropdown then the Send
   button stacked on that edge. */
.interview-jd {
  margin: 12px 0 0 56px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}

.interview-jd-select {
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #444444;
  font-size: 14px;
  background-color: #2a2a2a;
  color: #e0e0e0;
  cursor: pointer;
  min-width: 280px;
}

.interview-jd-send {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

/* Same height as the dropdown beside it, so the two sit on one line. */
.interview-jd-send .btn-primary {
  padding: 9px 14px;
  font-size: 14px;
  line-height: normal;
}

/* Import-from-email picker: the search form carries no trailing margin, so the
   results (or the empty-state line) start just under the search box. */
.email-attach-form {
  padding-bottom: 12px;
}

/* Results share the form's 30px side padding and close the modal with the same
   bottom padding, so the empty-state line and the rows sit inside the frame. */
.email-attach-results {
  padding: 0 30px 30px;
  max-height: 55vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.email-attach-error {
  color: #d99a2b;
  font-size: 13px;
}

.email-attach-empty {
  margin: 0;
  color: var(--color-text-muted);
}

/* Rows in the "Attach from email" picker (flex, not the pane grid). */
.email-attach-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 12px;
  background-color: var(--color-bg-hover);
  border-radius: 6px;
}

.email-attach-row .interview-step-actions {
  flex: 0 0 auto;
}

.email-attach-row .btn-primary,
.email-attach-row .btn-secondary {
  padding: 6px 12px;
  font-size: 13px;
  white-space: nowrap;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--color-bg-card);
  padding: 0;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid var(--color-border);
}

.modal-header h2 {
  margin: 0;
  color: var(--color-text-light);
  font-size: 1.5rem;
}

.modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: var(--color-text-muted);
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.modal-close:hover {
  background-color: var(--color-bg-hover);
  color: var(--color-text-light);
}

.schedule-form {
  padding: 30px;
}

.schedule-form .form-group {
  margin-bottom: 20px;
}

.schedule-form .form-group label {
  display: block;
  font-weight: 600;
  color: var(--color-text-light);
  margin-bottom: 8px;
}

.schedule-form .form-group input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
  background-color: var(--color-bg-hover);
  color: var(--color-text-light);
}

.schedule-form .form-group input:focus {
  outline: none;
  border-color: var(--wylie-purple);
  box-shadow: 0 0 0 3px rgba(80, 7, 120, 0.1);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 30px;
}

.reference-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.reference-verdict {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 12px;
}

.reference-positive {
  background-color: var(--wylie-green);
  color: white;
}

.reference-negative {
  background-color: #dc3545;
  color: white;
}

.flag-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  margin-left: 10px;
}

.flag-warning {
  background-color: #ffc107;
  color: #000;
}

/* Candidate Information inline edit form inputs */
.candidate-info-edit input,
.candidate-info-edit select {
  background-color: #6e4a8c; /* lighter shade of brand purple #500778 */
  color: #dcdce0;
  border: 1px solid #500778;
}
.candidate-info-edit input::placeholder {
  color: #cfc7d8;
}
/* The two multi-line boxes (reason for a temporary contract, Hours of work)
   are black on Pascal's request (2026-10-17), not the inputs' purple. */
.candidate-info-edit textarea {
  background-color: #000;
  color: #dcdce0;
  border: 1px solid #500778;
}
.candidate-info-edit textarea::placeholder {
  color: #9a93a3;
}

/* Archived strip — sits above the workflow panes to explain why this candidate is
   missing from the default list. Deliberately slim and unpanelled so it reads as a
   note, not as another section competing with Parts 1-5. */
.archived-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  flex-wrap: wrap;
  padding: 12px 18px;
  margin-bottom: 20px;
  border-left: 3px solid var(--wylie-purple);
  border-radius: 4px;
  background-color: var(--color-bg-card);
  color: var(--color-text-muted);
  font-size: 14px;
}

.archived-strip-action {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-weight: 600;
  color: var(--wylie-pink);
  cursor: pointer;
}

.archived-strip-action:hover:not(:disabled) {
  text-decoration: underline;
}

.archived-strip-action:disabled {
  color: var(--color-text-muted);
  cursor: default;
}

/* Second row of the strip: the rejection / offer-declined email's send status
   and its button. flex-basis 100% wraps it under the archive line. */
.archived-strip-email {
  flex-basis: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: var(--color-text-muted);
}
.archived-strip-email > span:first-child::first-letter {
  text-transform: uppercase;
}

/* Sticky candidate header — keeps the name, position and the way back visible
 * while scrolling through Parts 1-5, which are long enough to lose track of who
 * you are looking at.
 *
 * top: 60px parks it directly under the sticky Navigation bar (.navigation is
 * position:sticky/top:0 with a 60px-tall .nav-container) — at top:0 it would
 * slide underneath and be invisible.
 *
 * The negative side margins take it full-bleed across .container's 20px padding,
 * so page content can't scroll through the gutters beside it. That means the
 * background MUST stay opaque.
 *
 * The negative TOP margin is what makes it pinned from the very first pixel of
 * scroll. Without it the bar starts 40px lower (.navigation's 20px margin-bottom
 * plus .container's 20px padding-top) and visibly creeps upwards until it meets
 * the nav. Cancelling that gap puts the bar at its stuck position at rest, so
 * there is no travel, and the 40px goes back to the page instead.
 *
 * z-index sits above the in-page tooltips/dropdowns (100) and below the
 * Navigation (500), the modal overlay (1000) and the alert/confirm dialogs
 * (9998/9999), so nothing that should sit on top gets covered.
 *
 * Deliberately NOT reusing the global .page-header from App.css — that class is
 * shared with the candidate list, dashboard, create and users pages, which
 * should not become sticky.
 */
.candidate-sticky-header {
  position: sticky;
  top: 60px;
  z-index: 400;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin: -40px -20px 24px;
  padding: 14px 20px;
  background-color: var(--color-bg-dark);
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

/* Compact on purpose: the bar costs permanent vertical space on an already-long
 * page, so the name is smaller here than the 2rem of a normal .page-header h1. */
.candidate-sticky-header h1 {
  font-size: 1.5rem;
  color: var(--color-text-light);
  margin: 0;
}

.candidate-sticky-header .candidate-sticky-identity {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}

/* The position is the other fact you lose once Parts 3-5 scroll the info pane
   off screen. Truncates rather than wrapping, to keep the bar one line tall. */
.candidate-sticky-header .candidate-sticky-position {
  font-size: 1.03rem;
  color: var(--color-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.candidate-sticky-header .btn-primary {
  flex-shrink: 0;
}

/* Amber and yellow outlines: "Mark as Offer Declined" (Candidate Information) and
   Part 1's Import from email / Open interview form / Send J.D. Email. The outlined
   format itself lives in App.css — these only set the colour. Paired with
   .btn-primary so the compound selector outranks App.css's single-class variants
   whatever order the two stylesheets land in. Dark text on the amber and yellow
   fills — white on them is unreadable. .btn-fill-yellow is the "done" state (J.D. Email
   Sent). */
.btn-primary.btn-outline-amber {
  --btn-color: var(--declined-color);
  --btn-on-color: #1f1f1f;
}

.btn-primary.btn-outline-yellow {
  --btn-color: var(--part1-color);
  --btn-on-color: #1f1f1f;
}

.btn-primary.btn-fill-yellow {
  background-color: var(--part1-color);
  border: 1px solid var(--part1-color);
  color: #1f1f1f;
}

.btn-primary.btn-fill-yellow:hover:not(:disabled) {
  background-color: #e0bd00;
  border-color: #e0bd00;
}

/* Part 2's "Add Reference Manually": a min-width so the button does not shrink
   when its label toggles to "Cancel". */
.part1-action-btn {
  min-width: 200px;
}

/* The reason typed when a candidate was Rejected / declined the offer, to the
   right of the Current Status badge. pre-wrap keeps the line breaks typed into
   the box. Selectors go through .outcome-comment so they outrank \`.info-item span\`. */
.status-with-comment {
  display: flex;
  align-items: center;
  gap: 14px;
}

.status-with-comment .status-badge {
  flex-shrink: 0;
  font-size: 14px; /* as "Mark as Recruited"; \`.info-item span\` would make it 16px */
}

.outcome-comment {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: 600px;
}

.outcome-comment .outcome-comment-text {
  font-size: 14px;
  white-space: pre-wrap;
}

.outcome-comment .outcome-comment-meta {
  font-size: 12px;
  color: var(--color-text-muted);
}

/* A button whose label changes under the pointer ("Signed PDF" -> "View").
   Both labels occupy the same grid cell, so the button is sized by the longer
   one and does not jump when the text swaps. */
.hover-swap {
  display: inline-grid;
  text-align: center;
}
.hover-swap > span {
  grid-area: 1 / 1;
}
.hover-swap .hover-swap-hover,
.hover-swap:hover .hover-swap-rest {
  visibility: hidden;
}
.hover-swap:hover .hover-swap-hover {
  visibility: visible;
}

/* The Part 6 Training Log glow is the shared .next-glow in App.css. */

/* Part 2: the "Offer accepted" mark under Send Job Offer — the same circle as
   the Part 1 tick boxes, on one line with its label and date. */
.offer-accepted-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
  font-size: 14px;
}
.offer-accepted-row .interview-step-mark {
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CandidateDetail.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,kFAAkF;AAClF;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,sEAAsE;AACxE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;;;iFAIiF;AACjF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,SAAS;AACX;;AAEA;mDACmD;AACnD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;gFACgF;AAChF;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;0EAC0E;AAC1E;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;sBAEsB;AACtB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;iEACiE;AACjE;;;EAGE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;yEAEyE;AACzE;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;6EAC6E;AAC7E;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA,uCAAuC,iBAAiB,EAAE;AAC1D,uCAAuC,oBAAoB,EAAE;AAC7D,uCAAuC,mBAAmB,EAAE;;AAE5D;;6BAE6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oFAAoF;AACpF;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yCAAyC;EACzC,eAAe;EACf,eAAe;EACf,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;iCAEiC;AACjC;EACE,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,uEAAuE;AACvE;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;uEACuE;AACvE;EACE,oBAAoB;AACtB;;AAEA;+EAC+E;AAC/E;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,UAAU;EACV,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kDAAkD;AAClD;;EAEE,yBAAyB,EAAE,0CAA0C;EACrE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;wEACwE;AACxE;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;;AAEA;;2DAE2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;qEACqE;AACrE;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;EAyBE;AACF;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,sCAAsC;EACtC,4CAA4C;EAC5C,yCAAyC;AAC3C;;AAEA;iFACiF;AACjF;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,YAAY;AACd;;AAEA;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;WAMW;AACX;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;wCACwC;AACxC;EACE,gBAAgB;AAClB;;AAEA;;sFAEsF;AACtF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe,EAAE,iEAAiE;AACpF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;;+CAE+C;AAC/C;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA,sEAAsE;;AAEtE;gEACgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb","sourcesContent":[".detail-section {\n  background-color: var(--color-bg-card);\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  margin-bottom: 30px;\n}\n\n.detail-section h2 {\n  margin-bottom: 20px;\n  color: var(--color-text-light);\n}\n\n.section-toggle-arrow {\n  font-size: 0.9rem;\n  color: #888;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.detail-section h2:hover .section-toggle-arrow {\n  opacity: 1;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.info-item label {\n  font-weight: 600;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n}\n\n.info-item span {\n  color: var(--color-text-light);\n  font-size: 1rem;\n}\n\n.action-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.section-header h2 {\n  margin: 0;\n}\n\n.reference-form {\n  background-color: var(--color-bg-hover);\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.references-list {\n  display: grid;\n  gap: 15px;\n}\n\n.reference-card {\n  background-color: var(--color-bg-hover);\n  padding: 20px;\n  border-radius: 8px;\n  border-left: 4px solid var(--wylie-purple);\n}\n\n.reference-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.reference-card h3 {\n  margin: 0;\n  color: var(--color-text-light);\n}\n\n.reference-card p {\n  margin: 5px 0;\n  color: var(--color-text-muted);\n}\n\n.reference-status-badge {\n  display: inline-block;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 12px;\n  border: none;\n  background-color: var(--wylie-purple);\n  color: var(--wylie-white);\n  margin-left: 8px;\n}\n\n.reference-content {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid var(--color-border);\n}\n\n.reference-content p {\n  background-color: var(--color-bg-card);\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.reference-received-badge {\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  background-color: var(--wylie-green);\n  color: var(--wylie-white);\n  cursor: pointer;\n}\n\n.reference-received-subtext {\n  font-size: 10px;\n  font-weight: 400;\n  opacity: 0.9;\n}\n\n.reference-received-badge:hover {\n  background-color: #154a2a;\n}\n\n.reference-received-tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 400px;\n  max-width: 90vw;\n  max-height: 300px;\n  overflow-y: auto;\n  background-color: var(--color-bg-dark);\n  color: var(--color-text-light);\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  margin-bottom: 10px;\n  z-index: 100;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 1.5;\n  transition: visibility 0.2s, opacity 0.2s;\n}\n\n.tooltip-from {\n  font-weight: 600;\n  color: #a0a0a0;\n  margin-bottom: 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid var(--color-bg-hover);\n}\n\n.tooltip-body {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n/* A reference sent as an attachment: the file, in place of (or above) the body. */\n.tooltip-attachment {\n  margin-bottom: 10px;\n}\n\n.tooltip-attachment-hint {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n.reference-received-badge:hover .reference-received-tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.reference-received-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 20px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: var(--color-bg-dark) transparent transparent transparent;\n}\n\n.esig-gen-tip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 280px;\n  max-width: 90vw;\n  background-color: var(--color-bg-dark);\n  color: var(--color-text-light);\n  padding: 10px 12px;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  margin-bottom: 8px;\n  z-index: 100;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 1.5;\n  transition: opacity 0.08s;\n  pointer-events: none;\n}\n\n.esig-gen-tip-wrap:hover .esig-gen-tip {\n  visibility: visible;\n  opacity: 1;\n}\n\n.esig-gen-tip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 20px;\n  border-width: 8px;\n  border-style: solid;\n  border-color: var(--color-bg-dark) transparent transparent transparent;\n}\n\n.checklist {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.checklist-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background-color: var(--color-bg-hover);\n  border-radius: 6px;\n  transition: background-color 0.2s;\n}\n\n.checklist-item:hover {\n  background-color: var(--color-border);\n}\n\n.checklist-item input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--wylie-purple);\n}\n\n.checklist-item label {\n  cursor: pointer;\n  font-size: 1rem;\n  color: var(--color-text-light);\n  margin: 0;\n  user-select: none;\n}\n\n/* Interview pane (2026-10-03, regridded the same evening): every row shares ONE\n   grid — [mark 32px] [N. Label 210px] [detail, flexible] [actions 300px, right-aligned]\n   — so the step numbers form a column, the grey detail text starts in the same place\n   on every row, and the selects stack on one right edge. The calendar buttons sit\n   underneath as a supporting action; the job-description email is folded away. */\n.interview-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.interview-row {\n  display: grid;\n  grid-template-columns: 32px 240px minmax(0, 1fr) 300px;\n  column-gap: 12px;\n  align-items: center;\n  padding: 10px 12px;\n}\n\n.interview-step,\n.interview-step-group {\n  background-color: var(--color-bg-hover);\n  border-radius: 6px;\n}\n\n.interview-step-group {\n  padding: 4px 0 8px;\n}\n\n.interview-step-group .interview-row {\n  padding-top: 6px;\n  padding-bottom: 6px;\n}\n\n.interview-file-row .interview-step-label {\n  font-weight: 500;\n  color: var(--color-text-muted);\n  padding-left: 16px;\n}\n\n.interview-step-mark {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.interview-step-mark input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: var(--wylie-purple);\n  margin: 0;\n}\n\n/* Outcome rows carry a circle where the tick-box rows carry a checkbox, so the\n   left column reads as one line of status marks. */\n.interview-outcome-mark {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid var(--color-border);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.interview-outcome-mark.clickable {\n  cursor: pointer;\n}\n\n.interview-outcome-mark.clickable:hover,\n.interview-outcome-mark.clickable:focus-visible {\n  border-color: #9b4fc4;\n  outline: none;\n}\n\n.interview-toggle-label {\n  cursor: pointer;\n  user-select: none;\n}\n\n/* Yellow, not green: the pane's own colour (--part1-color). */\n.interview-outcome-mark.passed {\n  border-color: var(--part1-color);\n  color: var(--part1-color);\n}\n\n.interview-outcome-mark.failed {\n  border-color: var(--wylie-coral);\n  color: var(--wylie-coral);\n}\n\n.interview-step-label {\n  font-weight: 600;\n  color: var(--color-text-light);\n}\n\n/* \"N.\" in its own narrow column so the titles — and the \"Book on calendar\" link\n   beneath them — start at the same x: the B of Book under the I of Interview. */\n.interview-step-title {\n  display: grid;\n  grid-template-columns: 22px 1fr;\n  align-items: start;\n}\n\n.interview-step-no {\n  white-space: nowrap;\n}\n\n.interview-step-label label {\n  cursor: pointer;\n  margin: 0;\n  user-select: none;\n}\n\n.interview-step-detail {\n  font-size: 13px;\n  color: var(--color-text-muted);\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* \"Book on calendar\" sits as a quiet link UNDER the step label (Pascal found the\n   buttons too prominent); \"New form\" widened the link pair's last cell. */\n.btn-link-small.interview-sub-link {\n  display: block;\n  margin-top: 2px;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n/* Buttons line up on the LEFT edge of the action column (one column of buttons\n   down the pane); the link pairs are pushed to the right edge so their dots keep\n   their own column. */\n.interview-step-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.interview-steps select {\n  width: 150px;\n  padding: 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #444444;\n  background-color: #2a2a2a;\n  color: #e0e0e0;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n/* One button size inside the pane (the row buttons and the calendar footer alike);\n   the compound selectors outrank App.css's single-class rules. */\n.interview-steps .btn-primary,\n.interview-steps .btn-secondary,\n.interview-steps .btn-success {\n  padding: 6px 12px;\n  font-size: 14px;\n  white-space: nowrap;\n}\n\n/* \"View · Replace\" / \"Open form · New\": first link right-aligned, the dot, then the\n   second link in a fixed-width cell — so the dots line up down the column whatever\n   the words are. A lone \"Upload\" sits in the first cell, under \"View\". */\n.interview-link-pair {\n  display: grid;\n  grid-template-columns: 1fr 12px 80px;\n  align-items: center;\n  width: 190px;\n  flex: 0 0 190px;\n  margin-left: auto;\n}\n\n/* The dot between a link pair. Its own class on purpose: it used to borrow\n   .interview-step-detail, which became a grid and threw the dot 70px left. */\n.interview-link-dot {\n  font-size: 15px;\n  color: var(--color-text-muted);\n}\n\n.interview-link-pair > :nth-child(1) { justify-self: end; }\n.interview-link-pair > :nth-child(2) { justify-self: center; }\n.interview-link-pair > :nth-child(3) { justify-self: start; }\n\n/* The right-hand buttons (Import from email, Create form) end on the end of\n   \"New form\" (the link pair's last cell is wider than the word, so the pair's\n   edge is not the text's). */\n.interview-import-btn {\n  margin-right: 16px;\n}\n\n.btn-link-small {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 15px;\n  color: var(--color-text-light);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* View in the pane's yellow, Replace in coral (it overwrites the stored file). */\n.btn-link-small.btn-link-view {\n  color: var(--part1-color);\n}\n\n.btn-link-small.btn-link-replace {\n  color: var(--wylie-coral);\n}\n\n/* Hover in the Part 5 (Onboarding) purple — the brand purple reads too dark here. */\n.btn-link-small:hover:not(:disabled) {\n  color: #9b4fc4;\n}\n\n.btn-link-small:disabled {\n  color: var(--color-text-muted);\n  cursor: default;\n  text-decoration: none;\n}\n\n.interview-optional-toggle {\n  margin: 18px 0 0;\n  padding: 14px 0 0 56px;\n  border-top: 1px solid var(--color-border);\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--color-text-muted);\n  user-select: none;\n}\n\n.interview-optional-toggle:hover {\n  color: var(--color-text-light);\n}\n\n/* The unfolded job-description block: left edge under the step numbers (56px =\n   mark column + gap + row padding, same as the toggle), dropdown then the Send\n   button stacked on that edge. */\n.interview-jd {\n  margin: 12px 0 0 56px;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.interview-jd-select {\n  padding: 8px 12px;\n  border-radius: 5px;\n  border: 1px solid #444444;\n  font-size: 14px;\n  background-color: #2a2a2a;\n  color: #e0e0e0;\n  cursor: pointer;\n  min-width: 280px;\n}\n\n.interview-jd-send {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n/* Same height as the dropdown beside it, so the two sit on one line. */\n.interview-jd-send .btn-primary {\n  padding: 9px 14px;\n  font-size: 14px;\n  line-height: normal;\n}\n\n/* Import-from-email picker: the search form carries no trailing margin, so the\n   results (or the empty-state line) start just under the search box. */\n.email-attach-form {\n  padding-bottom: 12px;\n}\n\n/* Results share the form's 30px side padding and close the modal with the same\n   bottom padding, so the empty-state line and the rows sit inside the frame. */\n.email-attach-results {\n  padding: 0 30px 30px;\n  max-height: 55vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.email-attach-error {\n  color: #d99a2b;\n  font-size: 13px;\n}\n\n.email-attach-empty {\n  margin: 0;\n  color: var(--color-text-muted);\n}\n\n/* Rows in the \"Attach from email\" picker (flex, not the pane grid). */\n.email-attach-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 12px;\n  background-color: var(--color-bg-hover);\n  border-radius: 6px;\n}\n\n.email-attach-row .interview-step-actions {\n  flex: 0 0 auto;\n}\n\n.email-attach-row .btn-primary,\n.email-attach-row .btn-secondary {\n  padding: 6px 12px;\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: var(--color-bg-card);\n  padding: 0;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: var(--color-text-light);\n  font-size: 1.5rem;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: var(--color-text-muted);\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.modal-close:hover {\n  background-color: var(--color-bg-hover);\n  color: var(--color-text-light);\n}\n\n.schedule-form {\n  padding: 30px;\n}\n\n.schedule-form .form-group {\n  margin-bottom: 20px;\n}\n\n.schedule-form .form-group label {\n  display: block;\n  font-weight: 600;\n  color: var(--color-text-light);\n  margin-bottom: 8px;\n}\n\n.schedule-form .form-group input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n  background-color: var(--color-bg-hover);\n  color: var(--color-text-light);\n}\n\n.schedule-form .form-group input:focus {\n  outline: none;\n  border-color: var(--wylie-purple);\n  box-shadow: 0 0 0 3px rgba(80, 7, 120, 0.1);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 30px;\n}\n\n.reference-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.reference-verdict {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 12px;\n}\n\n.reference-positive {\n  background-color: var(--wylie-green);\n  color: white;\n}\n\n.reference-negative {\n  background-color: #dc3545;\n  color: white;\n}\n\n.flag-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  margin-left: 10px;\n}\n\n.flag-warning {\n  background-color: #ffc107;\n  color: #000;\n}\n\n/* Candidate Information inline edit form inputs */\n.candidate-info-edit input,\n.candidate-info-edit select {\n  background-color: #6e4a8c; /* lighter shade of brand purple #500778 */\n  color: #dcdce0;\n  border: 1px solid #500778;\n}\n.candidate-info-edit input::placeholder {\n  color: #cfc7d8;\n}\n/* The two multi-line boxes (reason for a temporary contract, Hours of work)\n   are black on Pascal's request (2026-10-17), not the inputs' purple. */\n.candidate-info-edit textarea {\n  background-color: #000;\n  color: #dcdce0;\n  border: 1px solid #500778;\n}\n.candidate-info-edit textarea::placeholder {\n  color: #9a93a3;\n}\n\n/* Archived strip — sits above the workflow panes to explain why this candidate is\n   missing from the default list. Deliberately slim and unpanelled so it reads as a\n   note, not as another section competing with Parts 1-5. */\n.archived-strip {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 15px;\n  flex-wrap: wrap;\n  padding: 12px 18px;\n  margin-bottom: 20px;\n  border-left: 3px solid var(--wylie-purple);\n  border-radius: 4px;\n  background-color: var(--color-bg-card);\n  color: var(--color-text-muted);\n  font-size: 14px;\n}\n\n.archived-strip-action {\n  padding: 0;\n  border: none;\n  background: none;\n  font: inherit;\n  font-weight: 600;\n  color: var(--wylie-pink);\n  cursor: pointer;\n}\n\n.archived-strip-action:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.archived-strip-action:disabled {\n  color: var(--color-text-muted);\n  cursor: default;\n}\n\n/* Second row of the strip: the rejection / offer-declined email's send status\n   and its button. flex-basis 100% wraps it under the archive line. */\n.archived-strip-email {\n  flex-basis: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  color: var(--color-text-muted);\n}\n.archived-strip-email > span:first-child::first-letter {\n  text-transform: uppercase;\n}\n\n/* Sticky candidate header — keeps the name, position and the way back visible\n * while scrolling through Parts 1-5, which are long enough to lose track of who\n * you are looking at.\n *\n * top: 60px parks it directly under the sticky Navigation bar (.navigation is\n * position:sticky/top:0 with a 60px-tall .nav-container) — at top:0 it would\n * slide underneath and be invisible.\n *\n * The negative side margins take it full-bleed across .container's 20px padding,\n * so page content can't scroll through the gutters beside it. That means the\n * background MUST stay opaque.\n *\n * The negative TOP margin is what makes it pinned from the very first pixel of\n * scroll. Without it the bar starts 40px lower (.navigation's 20px margin-bottom\n * plus .container's 20px padding-top) and visibly creeps upwards until it meets\n * the nav. Cancelling that gap puts the bar at its stuck position at rest, so\n * there is no travel, and the 40px goes back to the page instead.\n *\n * z-index sits above the in-page tooltips/dropdowns (100) and below the\n * Navigation (500), the modal overlay (1000) and the alert/confirm dialogs\n * (9998/9999), so nothing that should sit on top gets covered.\n *\n * Deliberately NOT reusing the global .page-header from App.css — that class is\n * shared with the candidate list, dashboard, create and users pages, which\n * should not become sticky.\n */\n.candidate-sticky-header {\n  position: sticky;\n  top: 60px;\n  z-index: 400;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  margin: -40px -20px 24px;\n  padding: 14px 20px;\n  background-color: var(--color-bg-dark);\n  border-bottom: 1px solid var(--color-border);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n/* Compact on purpose: the bar costs permanent vertical space on an already-long\n * page, so the name is smaller here than the 2rem of a normal .page-header h1. */\n.candidate-sticky-header h1 {\n  font-size: 1.5rem;\n  color: var(--color-text-light);\n  margin: 0;\n}\n\n.candidate-sticky-header .candidate-sticky-identity {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  min-width: 0;\n}\n\n/* The position is the other fact you lose once Parts 3-5 scroll the info pane\n   off screen. Truncates rather than wrapping, to keep the bar one line tall. */\n.candidate-sticky-header .candidate-sticky-position {\n  font-size: 1.03rem;\n  color: var(--color-text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.candidate-sticky-header .btn-primary {\n  flex-shrink: 0;\n}\n\n/* Amber and yellow outlines: \"Mark as Offer Declined\" (Candidate Information) and\n   Part 1's Import from email / Open interview form / Send J.D. Email. The outlined\n   format itself lives in App.css — these only set the colour. Paired with\n   .btn-primary so the compound selector outranks App.css's single-class variants\n   whatever order the two stylesheets land in. Dark text on the amber and yellow\n   fills — white on them is unreadable. .btn-fill-yellow is the \"done\" state (J.D. Email\n   Sent). */\n.btn-primary.btn-outline-amber {\n  --btn-color: var(--declined-color);\n  --btn-on-color: #1f1f1f;\n}\n\n.btn-primary.btn-outline-yellow {\n  --btn-color: var(--part1-color);\n  --btn-on-color: #1f1f1f;\n}\n\n.btn-primary.btn-fill-yellow {\n  background-color: var(--part1-color);\n  border: 1px solid var(--part1-color);\n  color: #1f1f1f;\n}\n\n.btn-primary.btn-fill-yellow:hover:not(:disabled) {\n  background-color: #e0bd00;\n  border-color: #e0bd00;\n}\n\n/* Part 2's \"Add Reference Manually\": a min-width so the button does not shrink\n   when its label toggles to \"Cancel\". */\n.part1-action-btn {\n  min-width: 200px;\n}\n\n/* The reason typed when a candidate was Rejected / declined the offer, to the\n   right of the Current Status badge. pre-wrap keeps the line breaks typed into\n   the box. Selectors go through .outcome-comment so they outrank `.info-item span`. */\n.status-with-comment {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.status-with-comment .status-badge {\n  flex-shrink: 0;\n  font-size: 14px; /* as \"Mark as Recruited\"; `.info-item span` would make it 16px */\n}\n\n.outcome-comment {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-width: 600px;\n}\n\n.outcome-comment .outcome-comment-text {\n  font-size: 14px;\n  white-space: pre-wrap;\n}\n\n.outcome-comment .outcome-comment-meta {\n  font-size: 12px;\n  color: var(--color-text-muted);\n}\n\n/* A button whose label changes under the pointer (\"Signed PDF\" -> \"View\").\n   Both labels occupy the same grid cell, so the button is sized by the longer\n   one and does not jump when the text swaps. */\n.hover-swap {\n  display: inline-grid;\n  text-align: center;\n}\n.hover-swap > span {\n  grid-area: 1 / 1;\n}\n.hover-swap .hover-swap-hover,\n.hover-swap:hover .hover-swap-rest {\n  visibility: hidden;\n}\n.hover-swap:hover .hover-swap-hover {\n  visibility: visible;\n}\n\n/* The Part 6 Training Log glow is the shared .next-glow in App.css. */\n\n/* Part 2: the \"Offer accepted\" mark under Send Job Offer — the same circle as\n   the Part 1 tick boxes, on one line with its label and date. */\n.offer-accepted-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 14px;\n}\n.offer-accepted-row .interview-step-mark {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
